import gql from 'graphql-tag'
export default gql`mutation deleteEnvironmentClassMutation($environmentClassId: Int!) {
  deleteEnvironmentClass(environmentClassId: $environmentClassId) {
    success
  }
}`